import WatchVideo from '@/components/video-list/WatchVideo.vue';
import VideoService from '@/services/VideoService';
export default {
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    WatchVideo
  },
  data: () => {
    return {
      video: null,
      loading: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    init: function () {
      this.loading = true;
      VideoService.fetch(this.id).then(response => {
        this.video = response.data;
      }).catch(err => {
        this.$aim.error(err.response);
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};